/* eslint-disable
    new-cap
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';

import makeCancelable from 'lib/makeCancelable';
import * as DateUtil from 'util/DateUtil';

import * as Helpers from './Helpers';

const {adminGet} = Helpers;

import ActivityRow from './ActivityRowTemplate';

class AdminLogView extends Backbone.View {
  static initClass() {
    this.prototype.el = '#activity-log';

    this.prototype.events = {'click .js-refresh': 'makeRequest'};
  }

  makeRequest() {
    this.$('.spinner').removeClass('hidden');
    this.$('tbody').empty();
    const args = {};
    const userValue = this.$('select').val();
    if (userValue) {
      args.user_id = userValue;
    }
    const q = this.$('.message-search').val();
    if (q.length !== 0) {
      args.q = q;
    }
    const dateSearch = this.$('.date-search input').val();
    if (dateSearch.length !== 0) {
      args.until = dateSearch;
    }
    if (this._searchPromise) {
      this._searchPromise.cancel();
    }
    this._searchPromise = makeCancelable(Promise.resolve(adminGet('/1/api/admin/search', args)));
    this._searchPromise.promise.then((res) => {
      this.$('.spinner').addClass('hidden');
      return (() => {
        const result = [];
        for (const info of Array.from(res)) {
          const row = ActivityRow({
            profile_url: info.profile_url,
            handle: info.handle,
            supportDelegateEmail: info.support_delegate_email,
            text: info.text,
            time: DateUtil.readableTime(new Date(info.created_at)),
          });
          result.push(this.$('tbody').append(row));
        }
        return result;
      })();
    });
  }

  render() {
    this.$('select').select2();
    return this.makeRequest();
  }
}
AdminLogView.initClass();

export default AdminLogView;
